import { useTranslation } from 'hooks';
import { Link } from 'react-router-dom';
import cls from './improvement-banner.module.scss';
import { Card } from '../card/card';
import { appRoute } from 'shared/constants/routes';

export const ImprovementBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card className={cls.banner}>
      <div>
        <h3>{t('centerBannerTitle')}</h3>
        <p>{t('centerBannerDescription')}</p>
      </div>
      <Link to={appRoute('/improvement-center')}>{t('centerBannerLink')}</Link>
    </Card>
  );
};
